<template>
    <div>
      <dailywork-report></dailywork-report>
    </div>
  </template>
  
  <script>
  export default {
  }
  </script>
  